import { dbui_v1_OperationalAlert } from '@antimatterhq/asl-api-ts-v1';
import { exhaustiveMatchingGuard } from '@/utils/util';

export const getAlertBadgeColorVariant = (
  state?: dbui_v1_OperationalAlert['state'],
) => {
  switch (state) {
    case 'dismissed':
      return 'success';
    case 'exported':
      return 'warning';
    case 'dismissedAsDuplicate':
      return 'success';
    case 'exportedAsDuplicate':
      return 'warning';
    case 'open':
      return 'info';
    case null:
    case undefined:
      return undefined;
    default:
      exhaustiveMatchingGuard(state);
  }
};
